import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LeaderboardOptions } from '@crazygames/game-types/src/game/leaderboard.type';

interface LeaderboardOptionsDisplayProps {
  leaderboardOptions: LeaderboardOptions;
}

const FIELD_CONFIGS: {
  key: keyof LeaderboardOptions;
  label: string;
}[] = [
  { key: 'encryptionKey', label: 'Encryption key' },
  { key: 'scoreSorting', label: 'Sorting' },
  { key: 'scoreLabel', label: 'Label' },
  { key: 'isIncremental', label: 'Is incremental' },
  { key: 'minValue', label: 'Min value' },
  { key: 'maxValue', label: 'Max value' },
  { key: 'cooldownSeconds', label: 'Cooldown (seconds)' },
];

const LeaderboardOptionsInfo: React.FC<LeaderboardOptionsDisplayProps> = ({ leaderboardOptions }) => {
  return (
    <Accordion sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Leaderboard options</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {FIELD_CONFIGS.map(({ key, label }) => {
            return (
              <Grid item xs={12} key={key}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="body1" fontWeight="medium">
                      {label}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Typography variant="body1">{leaderboardOptions[key].toString()}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default LeaderboardOptionsInfo;
